export function makeIsNormalInteger<T>(errorMsg: T) {
  return (value?: string | number) => {
    if (!value && value !== 0) {
      return undefined;
    }
    const valueEdited = value.toString().replace(/^0+/, '') || '0';
    const number = Math.floor(Number(valueEdited));

    if (number !== Infinity && String(number) === valueEdited && number >= 0) {
      return undefined;
    }

    return errorMsg;
  };
}
